module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiCn.e73e2bb.ttf";